module.exports = __webpack_public_path__ + "img/404.fe1a6fbc.jpg";